import { BasepageDirective } from "./basepage.directive";
import { ClickOutsideDirective } from "./clickoutside.directive";
import { InViewDirective } from "./in-view.directive";
import { RegisterButtonDirective } from "./register-button.directive";
import { TrapFocusDirective } from "./trap-focus.directive";
import { AnimateInDirective } from "./animate-in";
import { PreventHorizontalNavDirective } from "./prevent-horizontal-nav.directive";
import { DragToScrollDirective } from "./drag-to-scroll.directive";
import { UserHoverCardDirective } from "./user-hover-card.directive";
import { PaneResizerDirective } from "./pane-resizer.directive";
import { SeenInViewDirective } from "./seen-in-view.directive";

export const UI_DIRECTIVES = [
  BasepageDirective,
  ClickOutsideDirective,
  InViewDirective,
  RegisterButtonDirective,
  TrapFocusDirective,
  AnimateInDirective,
  PreventHorizontalNavDirective,
  DragToScrollDirective,
  UserHoverCardDirective,
  PaneResizerDirective,
  SeenInViewDirective,
];
